import React, { ChangeEvent, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { QuestionProps } from '../..';
import { QuestionnaireQuestionNotes } from '../../../QuestionnaireQuestionNotes';

export type SingleChoiceInputProps = Omit<
  QuestionProps,
  'type' | 'requiredChoices'
>;

const SingleChoice: React.FC<
  React.PropsWithChildren<SingleChoiceInputProps>
> = ({
  value,
  onChange,
  choices,
  notes,
  onChangeNotes,
  readOnly,
  showOptionalComment,
}) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <>
      {choices.map((choice) => (
        <Form.Check
          key={choice.value}
          type="radio"
          label={choice.label}
          value={choice.value}
          checked={value === choice.value}
          onChange={handleChange}
          readOnly={readOnly}
          disabled={readOnly}
        />
      ))}
      {showOptionalComment && (
        <QuestionnaireQuestionNotes
          value={notes}
          onChange={onChangeNotes}
          readOnly={readOnly}
        />
      )}
    </>
  );
};

export default SingleChoice;
